/* =======================================================================
      1) BLOQUEO ROBUSTO DE SLIDECART EN FUNNELS (SPA/BFCACHE/REACTIVO)
======================================================================= */

(function () {
  const BLOCK_KEYWORDS = [
    '/es/pages/skinny-coffee-en',
    '/es/pages/skinny-coffee',
    '/es/pages/ncb',
    '/pages/ncb',
    '/es/pages/collagen-protein-coffee-en',
    '/es/pages/ncb-vid',
    '/es/pages/skinny-coffee-m',
    '/pages/skinny-coffee-en-video',
    '/es/pages/collagen-protein-coffee',
    '/es/pages/skinny-coffee-s',
    '/pages/night-collagen-burn',
    '/pages/story',
    '/pages/story-ncb',
    '/pages/story-cpc',
    '/pages/historia',
    '/pages/historia-ncb',
    '/pages/historia-cpc'
  ];

  function isBlocked() {
    return BLOCK_KEYWORDS.some(k => location.href.includes(k));
  }

  if (!isBlocked()) return;

  window.__SLIDECART_BLOCKED__ = true;

  window.SLIDECART_OPEN = () => {};
  window.SLIDECART_TOGGLE = () => {};
  window.SLIDECART_UPDATE = window.SLIDECART_UPDATE || (() => {});

  const style = document.createElement('style');
  style.textContent = `
    #slidecarthq, .slidecarthq { display:none !important; }
    html.slidecarthq-open, body.slidecarthq-open { overflow:auto !important; }
  `;
  document.head.appendChild(style);
})();

/* =======================================================================
    2) CART GIFT RULES (CRAVE SAFE) - works on normal cart + slidecart
======================================================================= */

(function () {
  // Configuración de reglas y operaciones del carrito
  const THRESHOLDS = [
    { amount: 15, handles: ['free-fast-shipping'] },
    { amount: 70, handles: ['free-electric-coffee-mixer'] },
    { amount: 95, handles: ['free-skinny-coffee-tumbler'] }
  ];

  const PHYSICAL_GIFTS = ['free-skinny-coffee-tumbler', 'free-electric-coffee-mixer'];
  const REMOVED_HANDLES = ['night-collagen-burn-3'];

  // Función para actualizar el carrito
  function refreshCartPageOnce() {
    if (!onCartPage()) return;

    const now = Date.now();
    const last = Number(sessionStorage.getItem(CART_REFRESH_FLAG) || 0);

    if (now - last < CART_REFRESH_WINDOW_MS) return;

    sessionStorage.setItem(CART_REFRESH_FLAG, String(now));
    location.reload();
  }

  // Función que maneja los productos en el carrito
  async function checkAndRemoveProducts(cart) {
    const total = cart.total_price / 100;

    for (const t of THRESHOLDS) {
      if (total < t.amount) {
        for (const h of t.handles) {
          const it = cart.items.find(i => i.handle === h);
          if (it) await removeByKey(it.key);
        }
      }
    }

    await enforceGiftRules(cart);
  }

  // Trigger para cada cambio en el carrito
  window.SLIDECART_UPDATED = function (cart) {
    console.log('[SC NOTE] SlideCart updated');
    const interactionUpdate = isRecentCartInteraction();
    refreshUpsellsWithRetries(interactionUpdate);
    restoreAfterRemoveIfNeeded();
  };
})();